module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/past-work.json
// module id = 343
// module chunks = 10386043197574